import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {TaskFilterState} from './reducer/task-filter.reducer';

export const selectTaskFilterFeature = createFeatureSelector<TaskFilterState>(StoreKeys.TASK_FILTERS);

export const selectTaskFilterDatas = createSelector(selectTaskFilterFeature, state => state.datas);

export const selectTaskFilterDatasFilterItems = createSelector(selectTaskFilterFeature, state => state.datas.filterItems);
export const selectTaskFilterDatasLastAgg = createSelector(selectTaskFilterFeature, state => state.datas.lastAgg);
